import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/element-theme/index.css'
import './assets/css/base.css'
Vue.use(ElementUI)
router.beforeEach((to, from, next) => {
	// 路由发生变化修改页面title
	if (to.meta) {
		document.title = to.meta
	}
	// 修改浏览器标签页小图标
	let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
	link.type = 'image/x-icon'
	link.rel = 'shortcut icon'
	link.href =
		to.name == 'otherPay' ? require('./assets/images/xigua.png') : (link.href = require('./assets/logo.png')) //icon图标
	document.getElementsByTagName('head')[0].appendChild(link)
	next()
})
Vue.config.productionTip = false
Vue.prototype.$MONEY_NAME = '马帮通宝'
new Vue({
	router,
	render: (h) => h(App),
}).$mount('#app')
